import ShareableLinkPassword from './ShareableLinkPassword.component';

export default ShareableLinkPassword;
